import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import ListPage from "../../../layouts/page/ListPage";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import EmployeeSelect from "../../../components/Custom/Main/Employee/EmployeeSelect";
import CustomSelect from "../../../components/Forms/Element/CustomSelect";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { SearchOperation } from "../../../../utils/ApiUtils";
import { getScopeOptions, toBackendScope } from "./ScopeOptions";

const CommissionRuleList = () => {

    const { t } = useTranslation();
    const [employeeFilter, setEmployeeFilter] = useState(null);
    const [scopeTypeFilter, setScopeTypeFilter] = useState(null);
    const [filters, setFilters] = useState([]);

    const scopeTypeOptions = getScopeOptions(t);

    const handleSearch = () => {
        const activeFilters = [];

        if (employeeFilter) {
            activeFilters.push({
                field: "employee.id",
                value: employeeFilter.value,
                operation: SearchOperation.EQUAL
            });
        }

        // O filtro por "somente produtos" precisa apertar nos dois campos: sozinho, o
        // scopeType PRODUCT_TYPE traria também as regras de serviço.
        if (scopeTypeFilter) {
            const backendScope = toBackendScope(scopeTypeFilter.value);

            activeFilters.push({
                field: "scopeType",
                value: backendScope.scopeType,
                operation: SearchOperation.EQUAL
            });

            if (backendScope.scopeProductType) {
                activeFilters.push({
                    field: "scopeProductType",
                    value: backendScope.scopeProductType,
                    operation: SearchOperation.EQUAL
                });
            }
        }

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setEmployeeFilter(null);
        setScopeTypeFilter(null);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("commission_rules")} motherMenu={t("sales")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                {/* g-2 e as colunas md garantem que os filtros empilhem no celular em vez de
                    espremer os selects. */}
                <Row className="g-2 align-items-end">
                    <Col lg={4} md={6}>
                        <FormLabel>{t('employee')}</FormLabel>
                        <EmployeeSelect
                            value={employeeFilter}
                            onChange={setEmployeeFilter}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <FormLabel>{t('scope')}</FormLabel>
                        <CustomSelect
                            options={scopeTypeOptions}
                            value={scopeTypeFilter}
                            onChange={setScopeTypeFilter}
                            placeholder={t('select')}
                        />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t("commission_rules")}
                motherMenu={t("sales")}
                path={Api.sales.commission_rule}
                route={MenuConfig.sales.commission_rule.route}
                columns={Columns}
                filters={filters}
            />
        </>
    );
}

export default CommissionRuleList;
